import type { SlateBlock } from '@atlas/renderer';
import { Transforms, Editor, Range } from 'slate';
import handleMarkdownBlockFormattingKeyDownEvent from '@atlas/tool/box/slate/handleMarkdownBlockFormattingKeyDownEvent';
import handleInlineFormattingKeyDownEvent from '@atlas/tool/box/slate/handleInlineFormattingKeyDownEvent';
import getNode from '@atlas/tool/box/slate/getNode';
import removeTopLevelBlocks from '@atlas/tool/box/slate/removeTopLevelBlocks';
import parseMarkdown from './parseMarkdown';

export default function withMarkdown(editor: Editor): Editor {
    const { insertData, onKeyDown } = editor;

    editor.onKeyDown = (event) => {
        if (handleMarkdownBlockFormattingKeyDownEvent(editor, event)) return true;
        if (handleInlineFormattingKeyDownEvent(editor, event, '*', 'bold')) return true;
        if (handleInlineFormattingKeyDownEvent(editor, event, '_', 'italic')) return true;
        if (handleInlineFormattingKeyDownEvent(editor, event, '`', 'code')) return true;

        onKeyDown?.(event);
    };

    editor.insertData = (data) => {
        if (!editor.selection) return insertData(data);

        const content = data.getData('text/plain');
        if (!content) return insertData(data);

        const elements = parseMarkdown(content);

        if (elements.length === 1 && elements[0].type === 'paragraph') {
            Transforms.insertNodes(editor, elements[0].children);
        } else {
            let blockToRemove: null | number = null;

            if (editor.selection && Range.isCollapsed(editor.selection)) {
                const node = getNode<SlateBlock>(editor, [editor.selection.anchor.path[0]]);
                if (node && node.type === 'paragraph' && Editor.isEmpty(editor, node)) {
                    blockToRemove = editor.selection.anchor.path[0];
                }
            }

            Transforms.insertNodes(editor, elements);
            if (typeof blockToRemove === 'number') removeTopLevelBlocks(editor, blockToRemove);
        }
    };

    return editor;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('withMarkdown', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
